import type { ReactNode } from "react";
import { Collapse } from "~/common/mui";
import { CollapsibleCardContent, CollapsibleCardStyled, CollapsedTitleText, ToggleButton } from "./styled";
import { HeaderStyled } from "./styled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Divider } from "~/common/mui";

// ── CollapsedTitle ─────────────────────────────────────────────────────────

export const CollapsedTitle = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Divider orientation={"vertical"} flexItem />
      <CollapsedTitleText>{children}</CollapsedTitleText>
    </>
  );
};

// ── Header ─────────────────────────────────────────────────────────────────

interface HeaderProps {
  children: ReactNode;
  expanded?: boolean;
  onToggle: () => void;
  showToggle?: boolean;
}

export const Header = ({ children, expanded, onToggle, showToggle }: HeaderProps) => {
  return (
    <HeaderStyled>
      {children}
      {showToggle && (
        <ToggleButton onClick={onToggle} color={"secondary"} variant="contained" size="tiny">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ToggleButton>
      )}
    </HeaderStyled>
  );
};

// ── CollapsibleSection ─────────────────────────────────────────────────────

interface CollapsibleSectionProps {
  expanded?: boolean;
  onToggle: () => void;
  showToggle?: boolean;
  canExpand?: boolean;
  title: ReactNode;
  children: ReactNode;
}

export const CollapsibleSection = ({
  expanded,
  onToggle,
  showToggle,
  canExpand,
  children,
  title,
}: CollapsibleSectionProps) => {
  return (
    <CollapsibleCardStyled>
      <Header expanded={expanded} onToggle={onToggle} showToggle={showToggle}>
        {title}
      </Header>
      {canExpand && (
        <Collapse in={expanded}>
          <CollapsibleCardContent>{children}</CollapsibleCardContent>
        </Collapse>
      )}
    </CollapsibleCardStyled>
  );
};
